'use client'; // Added to mark as a Client Component

import React, { useState, useEffect } from 'react';
import ExternalLink from '../common/ExternalLink'; // ExternalLink をインポート

interface BookInfo {
  imageUrl: string;
  text: string;
  linkUrl: string;
}

const books: BookInfo[] = [
  {
    imageUrl: 'https://m.media-amazon.com/images/I/51gtcgHcAML._SY445_SX342_.jpg',
    text: 'スッキリわかるJava入門 第4版 (スッキリわかる入門シリーズ)',
    linkUrl: 'https://amzn.to/4k8g3J5',
  },
  {
    imageUrl: 'https://m.media-amazon.com/images/I/71vCdttxk8L._SY425_.jpg',
    text: 'スッキリわかるPython入門 第2版 (スッキリわかる入門シリーズ)',
    linkUrl: 'https://amzn.to/3YTmNlx',
  },
  {
    imageUrl: 'https://m.media-amazon.com/images/I/71YGu91UQeL._SY522_.jpg',
    text: 'はじめてつくるReactアプリ: HTMLとCSSの知識だけで始められるReact開発！ （React入門）',
    linkUrl: 'https://amzn.to/3SeFAEc',
  },
  {
    imageUrl: 'https://m.media-amazon.com/images/I/71LFwoCEF6L._SY522_.jpg',
    text: 'はじめてつくるバックエンドサーバー基礎編（Node.js & Express）: HTMLとCSSの知識だけでサーバーがつくれる本',
    linkUrl: 'https://amzn.to/4kqH9uv',
  },
  {
    imageUrl: 'https://m.media-amazon.com/images/I/91MQiT2yKOL._SY425_.jpg',
    text: 'スクラッチプログラミング事例大全集',
    linkUrl: 'https://amzn.to/3H6FbRN',
  },
];

const SLIDE_INTERVAL = 5000; // スライド切り替え間隔 (ミリ秒)

const UnderArea: React.FC = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    if (books.length === 0) return;

    const timer = setTimeout(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % books.length);
    }, SLIDE_INTERVAL);

    return () => clearTimeout(timer);
  }, [currentIndex]);

  const currentBook = books.length > 0 ? books[currentIndex] : null;

  return (
    <div className="bg-gradient-to-br from-slate-800 to-sky-700 text-white p-6 sm:p-8 mt-10">
      <div className="container mx-auto text-center">
        {/* 書籍スライドショーセクション */}
        {currentBook && (
          <div className="mb-12">
            <h3 className="text-xl font-semibold mb-6">おすすめ書籍</h3>
            <a
              href={currentBook.linkUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="block w-full max-w-xs mx-auto bg-white rounded-lg shadow-lg overflow-hidden transform transition-all duration-300 hover:shadow-xl hover:scale-105 group"
            >
              <div className="relative h-64 sm:h-72 w-full overflow-hidden">
                <img
                  src={currentBook.imageUrl}
                  alt={currentBook.text}
                  className="absolute inset-0 w-full h-full object-contain p-3 transition-transform duration-300 group-hover:scale-105"
                />
              </div>
              <div className="p-4 bg-gray-50">
                <h4
                  className="text-sm font-medium text-gray-800 truncate h-10 flex items-center justify-center"
                  title={currentBook.text}
                >
                  {currentBook.text}
                </h4>
              </div>
            </a>
          </div>
        )}

        {/* 既存の関連情報セクション */}
        <div>
          <h3 className="text-xl font-semibold mb-4">関連情報</h3>
          <div className="space-y-2">
            <ExternalLink
              href="https://amzn.to/3H03dxO" // このURLはダミーのままです。必要に応じて変更してください。
              text="プログラミング学習に役立つ情報"
              className="text-gray-400 hover:text-gray-200 transition-colors duration-150"
            />
            {/* 他にもリンクがあればここに追加できます */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default UnderArea;
